import React, { forwardRef } from 'react';

const InlineInput = forwardRef((props, ref) => (
  <input {...props} ref={ref} className="h-7 p-1 w-full font-bold text-lg focus:border border-gray-300 rounded" />
));

export default InlineInput;
